$.initialiseDropdown = () => {
  const dropdowns = document.getElementsByClassName('dropdown');

  let timer = null;
  const hideDropdowns = () => {
    const openDropdown = document.querySelector('.dropdown.open');
    if (openDropdown) {
      const openDropdownContainer = openDropdown.parentElement;
      const openDropdownContainerLink = openDropdownContainer.querySelector('.dropdown__btn');
      openDropdown.className = 'dropdown';
      openDropdownContainerLink.classList.remove('open');
      openDropdownContainer.classList.remove('open');
    }
  };

  function contains(parent, child) {
    return parent !== child && parent.contains(child);
  }

  function findAncestor (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  }

  const dropdownLink = document.querySelectorAll('.dropdown *');

  const navBar = document.querySelector('.primary-nav');


  Array.prototype.forEach.call(dropdownLink, (el) => {
    let dropdownContainerParent = findAncestor(el, 'dropdown__container');
    el.addEventListener('focusout', function(event) {
      if (event.relatedTarget !== null && !dropdownContainerParent.contains(event.relatedTarget)) {
        hideDropdowns();
        if(navBar){
          navBar.classList.remove('hide');
        }
      }
    });
    el.addEventListener('keydown', function(event) {
      if(event.keyCode == 27) {
        hideDropdowns();
        if(navBar){
          navBar.classList.remove('hide');
        }
      }
    });
  })


  let closeSearchButton = document.getElementsByClassName('js-close-search-trigger');
  if(closeSearchButton.length) {
    closeSearchButton[0].addEventListener('click', function(event) {
        hideDropdowns();
        if(navBar){
          navBar.classList.remove('hide');
        }
    });
  }

  //search bar
  const searchIcon = document.getElementsByClassName('btn--search');
    if(searchIcon.length) {
      searchIcon[0].addEventListener('click', function (e) {
        e.preventDefault();
        const parent = findAncestor(this, 'dropdown__container');
        const searchField = document.querySelector('.dropdown .form-textfield-input');
        setTimeout(function() {
          searchField.focus();
          if(navBar) {
            navBar.classList.toggle('hide');
          }

        }, 100);
      })
    }


  Array.prototype.forEach.call(dropdowns, (el) => {
    const dropdownContainer = el.parentElement;
    const dropdownContainerLink = dropdownContainer.querySelector('.dropdown__btn');

    dropdownContainerLink.addEventListener('keydown', function(event) {
      if(event.shiftKey && event.keyCode == 9 || event.keyCode == 27) {
        hideDropdowns();
        if(navBar){
          navBar.classList.remove('hide');
        }
      }
    });

    dropdownContainerLink.addEventListener('focusout', function(event) {
      if(!dropdownContainer.contains(event.relatedTarget) && event.relatedTarget){
          hideDropdowns();
          if(navBar){
            navBar.classList.remove('hide');
          }
      }
    });

    dropdownContainerLink.addEventListener('click', function(event) {

      //close mobile nav menu if clicking on dropdown in header
      const mobileMenu = document.querySelector('.menu-toggle');
      if(document.getElementsByClassName('primary-nav-open').length) {
        mobileMenu.click();
      }

      if(dropdownContainer.classList.contains('open')) {
        hideDropdowns();
      } else {
        hideDropdowns();
        el.className = 'dropdown open';
        clearTimeout(timer);
        dropdownContainer.classList.toggle('open');
      }

    });

    document.addEventListener("click", function(event) {
      const dropdownContainers = document.getElementsByClassName('dropdown__container');
      const hideDropdown = false;
      Array.prototype.forEach.call(dropdownContainers, (el) => {
        if(!el.contains(event.target)) {
          const hideDropdown = false;
        }
      })

      if(hideDropdown) {
        hideDropdowns();
        if(navBar){
          navBar.classList.remove('hide');
        }
      }
    })
  });
};

$.initialiseDropdown();
